import grapesjs from 'grapesjs';
import loadComponents from './components';
import loadBlocks from './blocks';

//
// Change this constant to something unique
//
export const blockRef = 'SetpointArrowButton';

export default grapesjs.plugins.add(`gjs-component-${blockRef}`, (editor, opts = {}) => {
    let c = opts;

    let defaults = {
        blockRef: blockRef,
        blockIcons: 'fa fa-sort',
        label: 'Arrow Button',
        labelCategory: 'Setpoint Controls',
        datapointList: []
    };

    // Load defaults
    for (let name in defaults) {
        if (!(name in c))
            c[name] = defaults[name];
    }

    // Add components
    loadComponents(editor, c);

    // Add components
    loadBlocks(editor, c);

});
